jQuery($ => {
    class Field {
      constructor(element) {
        this._         = element;
        this._element  = $(element);
        this._input    = this._element.find('input, select');
        this._clearBtn = this._element.find('.m-field__clear-button');
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        // when input is focused, set the --focused class
        this._input.on( 'focus', () => {
          this._element.addClass( 'm-field--focused' );
        });

        // when input is blurred, remove the --focused class
        // unless it has a value
        this._input.on( 'blur', () => {
          if ( this._input.val() === '' ) {
            this._element.removeClass( 'm-field--focused' );
          }
        });

        // if input has a value right now, set the --focused class
        if ( this._input.val() !== '' ) {
          this._element.addClass( 'm-field--focused' );

          // Show clear button if it exists
          if ( this._clearBtn ) {
            this._clearBtn.fadeIn();
          }
        }
        else {
          if ( this._clearBtn ) {
            this._clearBtn.hide();
          }
        }

        // when input changes value, set the --focused class
        this._input.on( 'change', () => {
          this._element.addClass( 'm-field--focused' );

          // Show clear button if it exists
          if ( this._clearBtn ) {
            if ( this._input.val() !== '' ) {
              this._clearBtn.fadeIn();
            }
            else {
              this._clearBtn.fadeOut();
            }
          }
        });

        if ( this._clearBtn ) {
          this._clearBtn.on( 'click', (e) => {
            e.preventDefault();
            this._input.val( '' ).trigger( 'change' );
          });
        }
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.field = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].field = new Field(_[i], opt);
        else
          ret = _[i].field[opt].apply(_[i].field, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-field').field();
});